/**
 * Design tokens - the single source of truth for the Octopus UI theme.
 *
 * Tokens are framework-agnostic constants. The MUI theme (`src/theme`) consumes
 * these to produce `darkTheme` / `lightTheme`. Stories and docs render directly
 * from tokens so the documentation can never drift from the implementation.
 */

export * from './colors';
export * from './surfaceScopes';
export * from './attackPath';
export * from './chart';
export * from './spacing';
export * from './radius';
export * from './shadows';
export * from './typography';
export * from './zIndex';
export * from './sizes';

import { colors } from './colors';
import { attackPath } from './attackPath';
import { chartTokens } from './chart';
import { spacing, spacingUnit } from './spacing';
import { radius, baseRadius } from './radius';
import { shadows } from './shadows';
import { typographyTokens } from './typography';
import { zIndex } from './zIndex';
import { chipHeights, controlHeights, drawerWidths } from './sizes';

/** Aggregate token object for convenient access and registry generation. */
export const tokens = {
  colors,
  attackPath,
  /** Per-mode data-visualisation palettes. See `tokens/chart.ts`. */
  chart: chartTokens,
  spacing,
  spacingUnit,
  radius,
  baseRadius,
  shadows,
  typography: typographyTokens,
  zIndex,
  drawerWidths,
  controlHeights,
  chipHeights,
} as const;

export type Tokens = typeof tokens;
